import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KENDO_GRID } from '@progress/kendo-angular-grid';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SupplierResponseModel } from './models/supplier-response-model';
import { ViewSupplierComponent } from './child-components/view-supplier.component';
import { SupplierV2 } from './models/item-response-model-v2';

@Component({
  selector: 'supplier-detail',
  standalone: true,
  imports: [CommonModule, NgbModule, KENDO_GRID],
  templateUrl: './supplier-detail.component.html',
  styles: [
    `
      :host ::ng-deep .k-grid .k-grid-header .k-table-th {
        font-weight: 700;
      }
      :host ::ng-deep .k-grid .k-table-td,
      :host ::ng-deep .k-grid .k-table-th {
        padding-top: 2px;
        padding-bottom: 2px;
      }
    `
  ]
})
export class SupplierDetailComponent {
  @Input() suppliers: SupplierResponseModel[] = [];
  @Input() loading: boolean = false;
  @Input() error: string = '';

  constructor(private modalService: NgbModal) {}

  public viewSupplier(supplier: SupplierResponseModel): void {
    const modalRef = this.modalService.open(ViewSupplierComponent, { size: 'size_60', scrollable: true });
    modalRef.componentInstance.supplierModel = this.mapToSupplierV2(supplier);
  }

  private mapToSupplierV2(supplier: SupplierResponseModel): SupplierV2 {
    return {
      supplierDetails: {
        supplierId: supplier.supplierId,
        supplierItemIdentification: supplier.supplierItemIdentification,
        supplierName: supplier.supplierName,
        siteId: supplier.siteId,
        legalEntity: supplier.legalEntity,
        legalEntityName: supplier.legalEntityName,
        countryOfOriginCode: supplier.countryOfOriginCode,
        countryOfOriginName: supplier.countryOfOriginName,
        customsStatisticalCode: supplier.customsStatisticalCode,
        stockCode: supplier.stockCode,
        stockCodeDescription: supplier.stockCodeDescription,
        isMainSupplier: supplier.isMainSupplier,
        isCoreItemOwner: supplier.isCoreItemOwner,
        isExternal: supplier.isExternal,
        baseUOMCode: supplier.baseUOMCode
      },
      leadtimes: {
        leadTimeDuration: supplier.leadTimeDuration,
        leadtimeQuantityLimit: supplier.leadtimeQuantityLimit,
        leadTimeDurationEnd: supplier.leadTimeDurationEnd,
        maxLeadTimeDuration: supplier.maxLeadTimeDuration,
        maxLeadTimeDurationEnd: supplier.maxLeadTimeDurationEnd
      },
      dimensions: {
        dimensionDescription: supplier.dimensionDescription,
        netWeight: supplier.netWeight,
        grossWeight: supplier.grossWeight,
        weightUoM: supplier.weightUoM,
        volume: supplier.volume,
        netVolume: supplier.netVolume,
        grossVolume: supplier.grossVolume,
        volumeUoM: supplier.volumeUoM,
        length: supplier.length,
        width: supplier.width,
        height: supplier.height,
        dimensionUoM: supplier.dimensionUoM
      },
      hazardousMaterial: {
        hazardousClass: supplier.hazardousClass,
        hazardousClassDescription: supplier.hazardousClassDescription
      },
      timestamps: {
        createdDateTime: supplier.createdDateTime,
        updateDateTime: supplier.updateDateTime,
        originalSourcePublishTime: supplier.originalSourcePublishTime,
        supplierCreatedDateTime: supplier.supplierCreatedDateTime,
        lastModificationDateTime: supplier.lastModificationDateTime
      }
    };
  }
}
